'use client';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import PropTypes from 'prop-types';
import { GlobalStyles } from '@mui/styled-engine';
import { useTheme as muiUseTheme } from '@mui/private-theming';
import useEnhancedEffect from '@mui/utils/useEnhancedEffect';
import ThemeProvider from "../ThemeProvider/index.js";
import InitColorSchemeScript, { DEFAULT_COLOR_SCHEME_STORAGE_KEY, DEFAULT_MODE_STORAGE_KEY } from "../InitColorSchemeScript/InitColorSchemeScript.js";
import useCurrentColorScheme from "./useCurrentColorScheme.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
export default function createCssVarsProvider(options) {
  var themeId = options.themeId,
    _options$theme = options.theme,
    defaultTheme = _options$theme === void 0 ? {} : _options$theme,
    _options$modeStorageK = options.modeStorageKey,
    defaultModeStorageKey = _options$modeStorageK === void 0 ? DEFAULT_MODE_STORAGE_KEY : _options$modeStorageK,
    _options$colorSchemeS = options.colorSchemeStorageKey,
    defaultColorSchemeStorageKey = _options$colorSchemeS === void 0 ? DEFAULT_COLOR_SCHEME_STORAGE_KEY : _options$colorSchemeS,
    _options$disableTrans = options.disableTransitionOnChange,
    designSystemTransitionOnChange = _options$disableTrans === void 0 ? false : _options$disableTrans,
    defaultColorScheme = options.defaultColorScheme,
    resolveTheme = options.resolveTheme;
  var defaultContext = {
    allColorSchemes: [],
    colorScheme: undefined,
    darkColorScheme: undefined,
    lightColorScheme: undefined,
    mode: undefined,
    setColorScheme: function setColorScheme() {},
    setMode: function setMode() {},
    systemMode: undefined
  };
  var ColorSchemeContext = /*#__PURE__*/React.createContext(undefined);
  if (process.env.NODE_ENV !== 'production') {
    ColorSchemeContext.displayName = 'ColorSchemeContext';
  }
  var useColorScheme = function useColorScheme() {
    return React.useContext(ColorSchemeContext) || defaultContext;
  };
  var defaultColorSchemes = {};
  var defaultComponents = {};
  function CssVarsProvider(props) {
    var _colorSchemes$restThe, _restThemeProp$palett, _memoTheme$generateSt;
    var children = props.children,
      themeProp = props.theme,
      _props$modeStorageKey = props.modeStorageKey,
      modeStorageKey = _props$modeStorageKey === void 0 ? defaultModeStorageKey : _props$modeStorageKey,
      _props$colorSchemeSto = props.colorSchemeStorageKey,
      colorSchemeStorageKey = _props$colorSchemeSto === void 0 ? defaultColorSchemeStorageKey : _props$colorSchemeSto,
      _props$disableTransit = props.disableTransitionOnChange,
      disableTransitionOnChange = _props$disableTransit === void 0 ? designSystemTransitionOnChange : _props$disableTransit,
      storageManager = props.storageManager,
      _props$storageWindow = props.storageWindow,
      storageWindow = _props$storageWindow === void 0 ? typeof window === 'undefined' ? undefined : window : _props$storageWindow,
      _props$documentNode = props.documentNode,
      documentNode = _props$documentNode === void 0 ? typeof document === 'undefined' ? undefined : document : _props$documentNode,
      _props$colorSchemeNod = props.colorSchemeNode,
      colorSchemeNode = _props$colorSchemeNod === void 0 ? typeof document === 'undefined' ? undefined : document.documentElement : _props$colorSchemeNod,
      _props$disableNestedC = props.disableNestedContext,
      disableNestedContext = _props$disableNestedC === void 0 ? false : _props$disableNestedC,
      _props$disableStyleSh = props.disableStyleSheetGeneration,
      disableStyleSheetGeneration = _props$disableStyleSh === void 0 ? false : _props$disableStyleSh,
      _props$defaultMode = props.defaultMode,
      initialMode = _props$defaultMode === void 0 ? 'system' : _props$defaultMode,
      noSsr = props.noSsr;
    var hasMounted = React.useRef(false);
    var upperTheme = muiUseTheme();
    var ctx = React.useContext(ColorSchemeContext);
    var nested = !!ctx && !disableNestedContext;
    var initialTheme = React.useMemo(function () {
      if (themeProp) {
        return themeProp;
      }
      return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
    }, [themeProp]);
    var scopedTheme = initialTheme[themeId];
    var restThemeProp = scopedTheme || initialTheme;
    var _restThemeProp$colorS = restThemeProp.colorSchemes,
      colorSchemes = _restThemeProp$colorS === void 0 ? defaultColorSchemes : _restThemeProp$colorS,
      _restThemeProp$compon = restThemeProp.components,
      components = _restThemeProp$compon === void 0 ? defaultComponents : _restThemeProp$compon,
      cssVarPrefix = restThemeProp.cssVarPrefix;
    var joinedColorSchemes = Object.keys(colorSchemes).filter(function (k) {
      return !!colorSchemes[k];
    }).join(',');
    var allColorSchemes = React.useMemo(function () {
      return joinedColorSchemes.split(',');
    }, [joinedColorSchemes]);
    var defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    var defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    var defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : ((_colorSchemes$restThe = colorSchemes[restThemeProp.defaultColorScheme]) === null || _colorSchemes$restThe === void 0 || (_colorSchemes$restThe = _colorSchemes$restThe.palette) === null || _colorSchemes$restThe === void 0 ? void 0 : _colorSchemes$restThe.mode) || ((_restThemeProp$palett = restThemeProp.palette) === null || _restThemeProp$palett === void 0 ? void 0 : _restThemeProp$palett.mode);

    // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
    var _useCurrentColorSchem = useCurrentColorScheme({
        supportedColorSchemes: allColorSchemes,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        defaultMode: defaultMode,
        storageManager: storageManager,
        storageWindow: storageWindow,
        noSsr: noSsr
      }),
      stateMode = _useCurrentColorSchem.mode,
      setMode = _useCurrentColorSchem.setMode,
      systemMode = _useCurrentColorSchem.systemMode,
      lightColorScheme = _useCurrentColorSchem.lightColorScheme,
      darkColorScheme = _useCurrentColorSchem.darkColorScheme,
      stateColorScheme = _useCurrentColorSchem.colorScheme,
      setColorScheme = _useCurrentColorSchem.setColorScheme;
    var mode = stateMode;
    var colorScheme = stateColorScheme;
    if (nested) {
      mode = ctx.mode;
      colorScheme = ctx.colorScheme;
    }
    var memoTheme = React.useMemo(function () {
      var _restThemeProp$genera;
      // `colorScheme` is undefined on the server and hydration phase
      var calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;

      // 2. get the `vars` object that refers to the CSS custom properties
      var themeVars = ((_restThemeProp$genera = restThemeProp.generateThemeVars) === null || _restThemeProp$genera === void 0 ? void 0 : _restThemeProp$genera.call(restThemeProp)) || restThemeProp.vars;

      // 3. Start composing the theme object
      var theme = _objectSpread(_objectSpread({}, restThemeProp), {}, {
        components: components,
        colorSchemes: colorSchemes,
        cssVarPrefix: cssVarPrefix,
        vars: themeVars
      });
      if (typeof theme.generateSpacing === 'function') {
        theme.spacing = theme.generateSpacing();
      }

      // 4. Resolve the color scheme and merge it to the theme
      if (calculatedColorScheme) {
        var scheme = colorSchemes[calculatedColorScheme];
        if (scheme && _typeof(scheme) === 'object') {
          // 4.1 Merge the selected color scheme to the theme
          Object.keys(scheme).forEach(function (schemeKey) {
            if (scheme[schemeKey] && _typeof(scheme[schemeKey]) === 'object') {
              // shallow merge the 1st level structure of the theme.
              theme[schemeKey] = _objectSpread(_objectSpread({}, theme[schemeKey]), scheme[schemeKey]);
            } else {
              theme[schemeKey] = scheme[schemeKey];
            }
          });
        }
      }
      return resolveTheme ? resolveTheme(theme) : theme;
    }, [restThemeProp, colorScheme, components, colorSchemes, cssVarPrefix]);

    // 5. Declaring effects
    // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
    var colorSchemeSelector = restThemeProp.colorSchemeSelector;
    useEnhancedEffect(function () {
      if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
        var selector = colorSchemeSelector;
        var rule = colorSchemeSelector;
        if (selector === 'class') {
          rule = ".%s";
        }
        if (selector === 'data') {
          rule = "[data-%s]";
        }
        if (selector !== null && selector !== void 0 && selector.startsWith('data-') && !selector.includes('%s')) {
          // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
          rule = "[".concat(selector, "=\"%s\"]");
        }
        if (rule.startsWith('.')) {
          var _colorSchemeNode$clas;
          (_colorSchemeNode$clas = colorSchemeNode.classList).remove.apply(_colorSchemeNode$clas, _toConsumableArray(allColorSchemes.map(function (scheme) {
            return rule.substring(1).replace('%s', scheme);
          })));
          colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
        } else {
          var matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
          if (matches) {
            var _matches$1$split = matches[1].split('='),
              _matches$1$split2 = _slicedToArray(_matches$1$split, 2),
              attr = _matches$1$split2[0],
              value = _matches$1$split2[1];
            if (!value) {
              // for attributes like `data-theme-dark`, `data-theme-light`
              // remove all the existing data attributes before setting the new one
              allColorSchemes.forEach(function (scheme) {
                colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
              });
            }
            colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
          } else {
            colorSchemeNode.setAttribute(rule, colorScheme);
          }
        }
      }
    }, [colorScheme, colorSchemeSelector, colorSchemeNode, allColorSchemes]);

    // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
    // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
    React.useEffect(function () {
      var timer;
      if (disableTransitionOnChange && hasMounted.current && documentNode) {
        var css = documentNode.createElement('style');
        css.appendChild(documentNode.createTextNode(DISABLE_CSS_TRANSITION));
        documentNode.head.appendChild(css);

        // Force browser repaint
        (function () {
          return window.getComputedStyle(documentNode.body);
        })();
        timer = setTimeout(function () {
          documentNode.head.removeChild(css);
        }, 1);
      }
      return function () {
        clearTimeout(timer);
      };
    }, [colorScheme, disableTransitionOnChange, documentNode]);
    React.useEffect(function () {
      hasMounted.current = true;
      return function () {
        hasMounted.current = false;
      };
    }, []);
    var contextValue = React.useMemo(function () {
      return {
        allColorSchemes: allColorSchemes,
        colorScheme: colorScheme,
        darkColorScheme: darkColorScheme,
        lightColorScheme: lightColorScheme,
        mode: mode,
        setColorScheme: setColorScheme,
        setMode: process.env.NODE_ENV === 'production' ? setMode : function (newMode) {
          if (memoTheme.colorSchemeSelector === 'media') {
            console.error(['MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).', 'To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.', 'To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually'].join('\n'));
          }
          setMode(newMode);
        },
        systemMode: systemMode
      };
    }, [allColorSchemes, colorScheme, darkColorScheme, lightColorScheme, mode, setColorScheme, setMode, systemMode, memoTheme.colorSchemeSelector]);
    var shouldGenerateStyleSheet = true;
    if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && (upperTheme === null || upperTheme === void 0 ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) {
      shouldGenerateStyleSheet = false;
    }
    var element = /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(ThemeProvider, {
        themeId: scopedTheme ? themeId : undefined,
        theme: memoTheme,
        children: children
      }), shouldGenerateStyleSheet && /*#__PURE__*/_jsx(GlobalStyles, {
        styles: ((_memoTheme$generateSt = memoTheme.generateStyleSheets) === null || _memoTheme$generateSt === void 0 ? void 0 : _memoTheme$generateSt.call(memoTheme)) || []
      })]
    });
    if (nested) {
      return element;
    }
    return /*#__PURE__*/_jsx(ColorSchemeContext.Provider, {
      value: contextValue,
      children: element
    });
  }
  process.env.NODE_ENV !== "production" ? CssVarsProvider.propTypes = {
    /**
     * The component tree.
     */
    children: PropTypes.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: PropTypes.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: PropTypes.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: PropTypes.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: PropTypes.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: PropTypes.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: PropTypes.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: PropTypes.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: PropTypes.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: PropTypes.bool,
    /**
     * The storage manager to be used for storing the mode and color scheme
     * @default using `window.localStorage`
     */
    storageManager: PropTypes.func,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: PropTypes.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: PropTypes.object
  } : void 0;
  var defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
  var defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
  var getInitColorSchemeScript = function getInitColorSchemeScript(params) {
    return InitColorSchemeScript(_objectSpread({
      colorSchemeStorageKey: defaultColorSchemeStorageKey,
      defaultLightColorScheme: defaultLightColorScheme,
      defaultDarkColorScheme: defaultDarkColorScheme,
      modeStorageKey: defaultModeStorageKey
    }, params));
  };
  return {
    CssVarsProvider: CssVarsProvider,
    useColorScheme: useColorScheme,
    getInitColorSchemeScript: getInitColorSchemeScript
  };
}